module.exports = __webpack_public_path__ + "screenshot.69927445e357f5ad0e27c714625c6c42.png";